import { useState } from 'react';
import './header.scss';
import { useLocation } from 'react-router-dom';
import { Logo, LogoBCP } from 'assets/images/svg';
import IconBurguer from 'components/icons/burguer';
import IconClose from 'components/icons/close';
import { principalBCPUrl, principalUrl } from 'libs/common/utils';

type ModifierHeader<T> = {
  [key: string]: T;
};



const Header: React.FC = () => {
  const route = useLocation();
  const pathname = route.pathname;

  const modifierHeader: ModifierHeader<string> = {
    [principalUrl]: '',
    [principalBCPUrl]: '--bcp',
    default: '',
  };

  const logoHeader: ModifierHeader<string> = {
    [principalUrl]: Logo,
    [principalBCPUrl]: LogoBCP,
    default: Logo,
  };

  const colorIconsHeader: ModifierHeader<string> = {
    [principalUrl]: '#0099CC',
    [principalBCPUrl]: '#FFF',
    default: '#0099CC',
  };

  const [isMenuMobileActive, setisMenuMobileActive] = useState(false);

  const openMenuMobile = () => {
    setisMenuMobileActive(!isMenuMobileActive);
  };

  const getRealOffset = (testId: string) => {
    let offsetTop = -1;
    const $elem = document.querySelector(`[data-testid=${testId}]`);
    $elem && (offsetTop = $elem.getBoundingClientRect().top + window.scrollY);
    return offsetTop;
  };

  const redirectToSection = (section: string) => {
    let offsetTop = 0;
    switch (section) {
      case 'inicio':
        offsetTop = 0;
        break;
      case 'benefits':
        offsetTop = getRealOffset('benefits') - 80;
        break;
      case 'plans':
        offsetTop = getRealOffset('plans') - 80;
        break;
      case 'testimonials':
        offsetTop = getRealOffset('testimonials') - 80;
        break;
      case 'faq':
        offsetTop = getRealOffset('faq') - 80;
        break;
      default:
        offsetTop = -1;
        break;
    }
    offsetTop >= 0 &&
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });

    offsetTop >= 0 && isMenuMobileActive && setisMenuMobileActive(false);
  };

  const addModifier = (className: string) => {
    return `${className} ${modifierHeader[pathname]
      ? className + modifierHeader[pathname]
      : modifierHeader['default']
      }`;
  };

  return (
    <nav className={addModifier('header')} data-testid="header">
      <button
        className="header__logo-mobile"
        onClick={() => openMenuMobile()}
        type="button"
        aria-label="Abrir menú"
      >
        <IconBurguer
          fill={colorIconsHeader[pathname] || colorIconsHeader['default']}
        />
      </button>
      <img
        className="header__button__logo"
        src={logoHeader[pathname] || logoHeader['default']}
        alt={'logo'}
        onClick={(e) => redirectToSection('inicio')}
      />
      <ul
        className={`header__content ${isMenuMobileActive ? 'header__content--mobile' : ''
          } `}
      >
        <div className={addModifier('header__content__action')}>
          <img
            className="header__content__action__logo"
            src={logoHeader[pathname] || logoHeader['default']}
            alt={'logo'}
          />
          <button
            className={addModifier('header__content__action__button')}
            onClick={() => openMenuMobile()}
            type="button"
          >
            Cerrar
            <IconClose
              fill={colorIconsHeader[pathname] || colorIconsHeader['default']}
            />
          </button>
        </div>
        <li className="header__content__links">
          <button
            className={addModifier('header__content__links__link')}
            onClick={(e) => redirectToSection('benefits')}
            type="button"
          >
            Descubre los beneficios
          </button>
        </li>
        <li className="header__content__links">
          <button
            className={addModifier('header__content__links__link')}
            onClick={(e) => redirectToSection('plans')}
            type="button"
          >
            Los mejores planes
          </button>
        </li>
        <li className="header__content__links">
          <button
            className={addModifier('header__content__links__link')}
            onClick={(e) => redirectToSection('testimonials')}
            type="button"
          >
            ¿Por qué Pacífico?
          </button>
        </li>
        <li className="header__content__links">
          <button
            className={addModifier('header__content__links__link')}
            onClick={(e) => redirectToSection('faq')}
            type="button"
          >
            Preguntas frecuentes
          </button>
        </li>
        <li className="header__content__links">
          <button
            className={addModifier('header__content__links__button')}
            onClick={(e) => redirectToSection('inicio')}
            type="button"
          >
            ¡Cotiza!
          </button>
        </li>
      </ul>
      <button
        className={addModifier('header__button')}
        onClick={(e) => redirectToSection('inicio')}
        type="button"
      >
        ¡Cotiza!
      </button>
    </nav>
  );
};

export default Header;
